import type { SalesminerOpportunity } from '@/types/serializers'
import type { NavigationData } from '@/types/NavigationData'
import OpportunityDetail from "@/salesminer/App/Opportunities/Show.tsx";

interface OpportunityDetailProps {
    opportunity: SalesminerOpportunity
    navigation_data: NavigationData
    back_path: string
}


export default function AccountOpportunityDetail({opportunity, navigation_data, back_path}: OpportunityDetailProps) {
    return <OpportunityDetail opportunity={opportunity} navigation_data={navigation_data} back_path={back_path}/>
}